<template>
    <div>
        <b-card
            class="mb-2"
            no-body
        >
            <template #header>
                <div class="d-flex align-items-center">
                    <div class="mr-3">
                        {{vocabulary_term.term}}
                    </div>
                    <div v-if="!readonly" class="ml-auto">
                        <b-dropdown
                            size="sm"
                            variant="secondary"
                            :disabled="se_locked"
                            dropleft
                        >
                            <template #button-content>
                                <font-awesome-icon :icon="['fad', 'cog']" />
                            </template>
                            <b-dropdown-item
                                @click="editVocabularyTerm"
                                :disabled="!can_update_article"
                            >
                                <font-awesome-icon :icon="['fad', 'edit']" class="text-primary" fixed-width /> Edit
                            </b-dropdown-item>
                            <b-dropdown-item
                                @click="removeVocabularyTerm"
                                :disabled="!can_update_article"
                            >
                                <font-awesome-icon :icon="['far', 'minus']" class="text-danger" fixed-width /> Remove
                            </b-dropdown-item>
                        </b-dropdown>
                    </div>
                </div>
            </template>

            <b-card-body>
                <div>
                    <div class="d-flex">
                        <div>
                            <span class="text-muted">Definition:</span>
                        </div>
                        <div class="ml-1">
                            {{vocabulary_term.definition}}
                        </div>
                    </div>
                    <div v-if="vocabulary_term.sentence" class="d-flex">
                        <div>
                            <span class="text-muted">Sentence:</span>
                        </div>
                        <div class="ml-1" v-html="vocabulary_term.sentence" />
                    </div>
                </div>
                <div
                    v-if="vocabulary_term.image && vocabulary_term.image.src"
                    :class="{'merlin-asset-border': isMerlinMedia}"
                >
                    <div class="merlin-asset-wrapper">
                        <span
                            v-if="isMerlinMedia"
                            class="merlin-asset-warning"
                        >
                            <font-awesome-icon :icon="['fas', 'exclamation-triangle']" fixed-width />
                            Merlin Asset
                        </span>
                    </div>
                    <div class="d-flex my-3">
                        <div>
                            <span class="text-muted">Image:</span>
                        </div>
                        <b-link :href="vocabulary_term.image.src" target="_blank">
                            <b-img
                                :src="vocabulary_term.image.src"
                                width="75"
                                height="auto"
                                class="p-0 mx-2 mb-3"
                                thumbnail>
                            </b-img>
                        </b-link>
                    </div>
                </div>           
            </b-card-body>
        </b-card>

        <vocabulary-term-modal
            v-model="show_vocabulary_term_modal"
            :article="article"
            :vocabulary_term="vocabulary_term"
            :vocabulary_terms="vocabulary_terms"
            @update="updateVocabularyTerm"
            @hide="show_vocabulary_term_modal = false"
        />

    </div>
</template>

<style lang="scss" scoped>

</style>

<script>
import { mapState } from 'vuex'
import VocabularyTermModal from '@/components/modals/article/VocabularyTermModal'

export default {
    data: () => ({
        show_vocabulary_term_modal: false
    }),
    props: [
        'publication',
        'unit',
        'article',
        'vocabulary_term',
        'vocabulary_terms',
        'readonly',
    ],
    components: {
        VocabularyTermModal
    },
    computed: {
        ...mapState({
            user: state => state.user.user,
        }),
        isMerlinMedia() {
            const termHasImage = this.vocabulary_term && this.vocabulary_term.image && this.vocabulary_term.image.src
            if (!termHasImage) {
                return false
            }

            return this.vocabulary_term.image.src.toLowerCase().includes('merlinone')
        },
        can_update_article() {
            return this.user && this.user.permissions && _.includes(this.user.permissions, 'update_article')
        },
        se_locked() {
            let se_locked

            if (
                this.publication.se_locked ||
                this.unit.se_locked
            ) {
                se_locked = true
            } else {
                se_locked = false
            }

            return se_locked
        }
    },
    methods: {
        editVocabularyTerm() {
            this.show_vocabulary_term_modal = true
        },
        updateVocabularyTerm(vocabulary_term) {
            this.axios.post('/api/articles/update_vocabulary/' + this.article.article_id, {
                vocabulary_term_id: vocabulary_term.vocabulary_term_id,
                vocabulary_term: vocabulary_term.term,
                definition: vocabulary_term.definition,
                image: vocabulary_term.image,
                sentence: vocabulary_term.sentence
            })
            .then(() => {
                let index = _.findIndex(this.vocabulary_terms, {vocabulary_term_id: this.vocabulary_term.vocabulary_term_id})

                this.vocabulary_terms.splice(index, 1, vocabulary_term)

                this.show_vocabulary_term_modal = false
            })
        },
        async removeVocabularyTerm() {
            const termInUse = await this.$store.dispatch('termInCrossword', {unitId: this.unit.id, termId: this.vocabulary_term.vocabulary_term_id})
            let message = null
            if (this.vocabulary_term.term) {
                message = 'Are you sure you want to remove the vocabulary term <strong>' + this.vocabulary_term.term + '</strong> from this article?'
                if (termInUse) {
                    message += '<p class="mt-3 mb-0"><strong>Warning:</strong> This term is used by the crossword for this week. Removing it will reset the crossword.</p>'
                }
            } else {
                message = 'Are you sure you want to remove this vocabulary term from this article?'
            }

            const result = await this.$swal({
                html: message,
                showCancelButton: true,
                confirmButtonText: 'Remove Vocabulary Term',
                cancelButtonText: 'Cancel',
                reverseButtons: true
            })
            if (!result.value) {
                return
            }
            const response = await this.axios.post('/api/articles/remove_vocabulary/' + this.article.id, {
                vocabulary_term_id: this.vocabulary_term.vocabulary_term_id
            })
            if (response.data) {
                if (termInUse) {
                    await this.$store.dispatch('saveCrossword', {json: null, unit_id: this.unit.id})
                }
                this.$emit('unlink')
            }
        },
    },
}
</script>
